import PrevisionTableForecast from "./prevision-table/PrevisionTableForecast";

import { WEATHER_STORE } from "@/store/store";
import { useDispatch, useSelect } from "@wordpress/data";
import { getPrevisionButtonStatus } from "../helpers/prevision-button-helper";
import { WeatherDispatch, WeatherSelect } from "@/store/type";
import { useTranslation } from "react-i18next";

import PrevisionButton from "@/components/prevision-button/PrevisionButton";
import Skeleton from "@/components/skeletons/Skeleton";

import "./style.scss";

export const App = () => {
	const { t } = useTranslation();
	const { setPrevisionDate } = useDispatch(WEATHER_STORE) as WeatherDispatch;

	const { date, forecastData, isLoading, error } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
			const store = select(WEATHER_STORE);

			const { cityId } = store.getCityLocationState();
			return {
				date: store.getDateSelectedCityState(),
				cityId,
				...store.getCityPrevisionState(),
			};
		},
		[],
	);

	return (
		<div className="weather-forecast-prevision-city">
			<PrevisionButton
				isPrev={true}
				isActive={getPrevisionButtonStatus({
					direction: "prev",
					dateSelected: date,
				})}
				handleClick={(action: "prev" | "next") =>
					setPrevisionDate({
						action,
						forecastType: "weather",
						dateStore: date,
					})
				}
			/>
			<div className="table-wrapper">
				{isLoading ? (
					<div className="table-wrapper" style={{ height: 400 }}>
						<div className="prevision-table">
							<Skeleton length={8} />
						</div>
					</div>
				) : error ? (
					<div className="error">
						<p>{t("fetchError")}</p>
					</div>
				) : (
					forecastData && (
						<PrevisionTableForecast
							dateSelected={date}
							data={forecastData.data}
						/>
					)
				)}
			</div>
			<PrevisionButton
				isPrev={false}
				isActive={getPrevisionButtonStatus({
					direction: "next",
					dateSelected: date,
					addDate: 9,
				})}
				handleClick={(action: "prev" | "next") =>
					setPrevisionDate({
						action,
						forecastType: "weather",
						dateStore: date,
					})
				}
			/>
		</div>
	);
};

export default App;
